import React from 'react';

import RoundDitail from '../../RoundDitail';

function BetTimeRoomContentPC({ isRoomPointInsufficient, viewProps }) {
  return (
    <>
      <RoundDitail
        {...viewProps}
        isRoomPointInsufficient={isRoomPointInsufficient}
      />
    </>
  );
}

export default BetTimeRoomContentPC;
